import baseURL from "../common/axios";
class SiteVisitService {
  //To Insert Task-->MOPCRM API
  create(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Task/Create", dataModel);
  }
  //To Update Task-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Task/Update", dataModel);
  }
  updateServicepipeLine(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post(
      "Task/updateServicepipeLine",
      dataModel
    );
  }
  //To Delete Task-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete("Task/Delete?id=" + Id);
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "Task/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get Task List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("Task/List");
  }
  //To Get Task List based on pagination-->MOPCRM API
  getListCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    condition,
    Flag,
    SearchOption
  ) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/ListCustom?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
  //To Get All Task List Query-->MOPCRM API
  getListAll(startDate, endDate, condition, Flag, SearchOption) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/ListAll?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
  getServicePipeLineListAll(startDate, endDate, condition, Flag, SearchOption) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/ServicePipeLineListAll?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&Condition=" +
      condition +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      ""
    );
  }
  //To Get Task List-->MOPCRM API
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Task/Get?id=" + Id + "");
  }
  //To Get Task Status List-->MOPCRM API
  taskStatusList() {
    return baseURL.httpMSMOPCRMUrl.get("TaskStatus/List");
  }
  //To Get Priority List-->MOPCRM API
  priorityList() {
    return baseURL.httpMSMOPCRMUrl.get("Priority/List");
  }

  GetSiteVisitDashboardCustom(branch, AgentId, admin, clientId) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/GetSiteVisitDashboardCustom?branch=" +
      branch +
      "&AgentId=" +
      AgentId +
      "&admin=" +
      admin +
      "&clientId=" +
      clientId
    );
  }

  //To Get List From Task Management-->MOPCRM API
  GetListFromTaskMgmt(clientId, branchId, isAdmin, isDepartmentHead, userId, DeptRoleMapId, TaskCategory) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/GetListFromTaskMgmt?clientId=" +
      clientId +
      "&branchId=" +
      branchId +
      "&isAdmin=" +
      isAdmin +
      "&isDepartmentHead=" +
      isDepartmentHead +
      "&userId=" +
      userId +
      "&DeptRoleMapId=" +
      DeptRoleMapId +
      "&TaskCategory=" +
      TaskCategory
    );
  }

  //To Get Task By Task Id-->MOPCRM API
  GetTaskByTaskId(Id) {
    return baseURL.httpMSMOPCRMUrl.get("Task/GetTaskByTaskId?Id=" + Id);
  }

  //To Get Status By Task Type Id-->MOPCRM API
  GetStatusByTaskTypeId(TaskTypeId) {
    return baseURL.httpMSMOPCRMUrl.get("Task/GetStatusByTaskTypeId?TaskTypeId=" + TaskTypeId);
  }

  //To Get List User By Sub Department Id-->MOPCRM API
  ListUserBySubDeptId(OrganizationId, SubDeptId, userName) {
    return baseURL.httpMSMOPCRMUrl.get(
      "Task/ListUserBySubDeptId?OrganizationId=" +
      OrganizationId +
      "&SubDeptId=" +
      SubDeptId +
      "&userName=" +
      userName
    );
  }

  //To Update Task Activity-->MOPCRM API
  UpdateTaskActivity(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post("Task/UpdateTaskActivity", dataModel);
  }
}
export default new SiteVisitService();
